<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<the-mask
			type="text"
			:value="value"
			@input="onInput"
			class="form-control input-sm"
			:placeholder="placeholder"
			:mask="inputMask"
			:disabled="disabled"
		/>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
import {TheMask} from 'vue-the-mask'

export default {
	methods: {
		onInput(value) {
			this.$emit('input', value)
		}
	},

	computed: {
		inputMask() {
			if (this.cepMask) {
				return '#####-###'
			} else if (this.telefoneMask) {
				return ['(##) ####-####', '(##) #####-####']
			} else if (this.numeroMask) {
				return [...Array(this.tamanhoMaximoNumero).keys()].map((indexTamanho) => {
					return '#'.repeat(indexTamanho + 1) + this.unidadeNumero
				})
			}

			return null
		}
	},

	components: {TheMask},

	props: {
		label: {
			type: String,
			required: true
		},

		placeholder: {
			type: String,
			required: false,
			default: ''
		},

		value: {
			type: [String, Number],
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		numeroMask: {
			type: Boolean,
			required: false,
			default: false
		},

		tamanhoMaximoNumero: {
			type: Number,
			required: false,
			default: 12
		},

		unidadeNumero: {
			type: String,
			required: false,
			default: ''
		},

		cepMask: {
			type: Boolean,
			required: false,
			default: false
		},

		telefoneMask: {
			type: Boolean,
			required: false,
			default: false
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	}
}
</script>